import useUploadQueue from "./useUploadQueue";
import useUploadState from "./useUploadState";
import {UPLOADING_STATUS} from "../constants";

const getDefaultUploadStates = (files) => {
    const defaultUploadStates = [...new Array(files.length)].map(
        (elem, index) => {
            const defaultUploadState = {
                id: index,
                status: "",
                progress: 0,
                error: null,
            };
            return defaultUploadState;
        }
    );

    return defaultUploadStates;
};

const getWaitingFiles = (files) => {
    const waitingFiles = [...new Array(files.length)].map((elem, index) => {
        return {
            id: index,
        };
    });

    return waitingFiles;
};

/**
 * Приводит ошибку файла к тексту для отображения в списке.
 * Ошибка приходит либо от клиентской проверки, либо от DRF
 * в виде { поле: ["текст"] }.
 */
const getFileErrorMessage = (error) => {
    if (!error) {
        return "";
    }

    if (typeof error === "string") {
        return error;
    }

    if (Array.isArray(error)) {
        return error.join(", ");
    }

    return Object.values(error)
        .map((value) => (Array.isArray(value) ? value.join(", ") : value))
        .filter(Boolean)
        .join(", ");
};

const handleDefault = (e) => {
    e.stopPropagation();
    e.preventDefault();
};

const handleDragEnter = (e, setIsDragging) => {
    setIsDragging(true);
    handleDefault(e);
};

const handleDragLeave = (e, setIsDragging) => {
    setIsDragging(false);
    handleDefault(e);
};

const handleDrop = (e, status, setIsDragging, addFiles) => {
    setIsDragging(false);
    handleDefault(e);

    if (status !== UPLOADING_STATUS.Loading) {
        addFiles([...e.dataTransfer.files]);
    }
};

export {
    useUploadQueue,
    useUploadState,
    getDefaultUploadStates,
    getFileErrorMessage,
    getWaitingFiles,
    handleDefault,
    handleDragEnter,
    handleDragLeave,
    handleDrop,
};
